import React, { useState } from "react";
import { Alert } from "react-bootstrap";
export default function BrowserAlert() {
  const [showAlert, setShowAlert] = useState(true);
  return (
    <Alert
      variant={"warning"}
      dismissible={true}
      show={showAlert}
      onClose={() => setShowAlert(false)}
    >
      <p>
        Nếu bạn mở trang này trên điện thoại, bạn hãy copy{" "}
        <a href={"/tet/loc-xuan"}>liên kết này</a> và mở trên Safari hoặc Chrome
        mới có thể download được.
      </p>
    </Alert>
  );
}
